import View             from '@widesk-ui/components/View';
import TriStateSwitch    from '@/TokamapEditor/ux/TriStateSwitch';
import useDesignTokens   from '@/hooks/useDesignTokens';
import React             from 'react';

/**
 * Interrupteur booléen inline (switch + libellé + description sur une seule ligne) — plutôt qu'un
 * `Field` classique (label en gras au-dessus, contrôle en dessous, pensé pour les couleurs/sliders) :
 * un switch seul sous un gros label flottait visuellement mal. Factorisé depuis
 * `AreaImageSection.tsx` ("Conserver l'orientation") pour être réutilisé tel quel par
 * `AreaThemeSection.tsx` ("Bordure en pointillés") et `SettingsSidebar.tsx` ("Activer la
 * géolocalisation", "Activer la 3D") plutôt que de dupliquer ce balisage.
 */
export default function SwitchField({ label, help, value, mixed, disabled, onChange }: {
	label: React.ReactNode;
	help?: React.ReactNode;
	value: boolean;
	mixed?: boolean;
	disabled?: boolean;
	onChange: (checked: boolean) => void;
}) {
	const tokens = useDesignTokens();

	return (
		<View row gap="xs" centerV>
			<TriStateSwitch value={value} mixed={mixed} disabled={disabled} onChange={onChange} />

			<span style={{ color: tokens.text.muted, fontSize: 12.5, lineHeight: 1.4, opacity: disabled ? 0.5 : 1 }}>
				<span style={{ color: tokens.text.default, fontWeight: 'bold' }}>{label}</span>
				{!!help && <span>&nbsp;— {help}</span>}
			</span>
		</View>
	);
}
